module.exports = __webpack_public_path__ + "img/idea.dc57dc47.png";